import { Col, Row, Button, Form, FormInstance } from 'antd';
import './index.css';

export interface SearchFormItem {
  name: string;
  label: string;
  component: React.ReactNode;
}

interface SearchFormProps {
  form: FormInstance;
  onFinish: () => void;
  items: SearchFormItem[];
}

const SearchForm = ({ form, onFinish, items }: SearchFormProps) => {
  return (
    <Form
      className="search-form-container"
      form={form}
      name="searchForm"
      onFinish={onFinish}
      labelCol={{
        xs: { span: 8 },
      }}
      wrapperCol={{
        xs: { span: 16 },
      }}
      labelAlign="left"
    >
      <Row gutter={{ xs: 8, sm: 16, md: 24 }}>
        {items.map((item) => (
          <Col span={8} xs={24} sm={16} md={8} key={item.name}>
            <Form.Item name={item.name} label={item.label}>
              {item.component}
            </Form.Item>
          </Col>
        ))}
      </Row>
      <div>
        <Button type="primary" htmlType="submit">
          搜索
        </Button>
      </div>
    </Form>
  );
};

export default SearchForm;
